const generateGoogleMapsLink = (address) => {
  const formattedAddress = address?.replace(/ /g, '+');

  return `https://www.google.com/maps?q=${formattedAddress}`;
}

export default generateGoogleMapsLink;
